import { render, staticRenderFns } from "./WordDocuments.vue?vue&type=template&id=411f6358&scoped=true&"
import script from "./WordDocuments.vue?vue&type=script&lang=js&"
export * from "./WordDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f6358",
  null
  
)

export default component.exports